import React from 'react';
import dayjs from 'dayjs';
import DatePicker from '@/components/basic/date-picker';
const calendar = require('@/assets/icons/calendar.webp');
import {Image} from 'antd-mobile';
import {DownIcon} from '@/common-pages/casino/svg.variable';
export interface SelectDateType {
  value?: Date;
  onChange?: (v: Date) => void;
}

const SelectDate = (props: SelectDateType) => {
  const {value, onChange} = props;
  const [showDate, setShowDate] = React.useState(false);
  return (
    <DatePicker
      titleRender={
        <div className="h-12 flex flex-row items-center justify-between bg-white rounded-lg px-3">
          <Image src={calendar} className="size-4" />
          <div className="flex flex-row gap-3">
            <span className="text-t1 font-bold text-sm">
              {dayjs(value).format('YYYY-MM')}
            </span>
            <DownIcon className="size-3.5" />
          </div>
        </div>
      }
      open={showDate}
      setOpen={setShowDate}
      type="month"
      value={value}
      onValueChange={onChange}
    />
  );
};

export default SelectDate;
